"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wizard = void 0;
var react_1 = __importDefault(require("react"));
var strings_1 = __importDefault(require("../strings"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var kinsideTokens_1 = require("./../kinsideTokens");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    button: {
        marginRight: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        '& path': {
            fill: kinsideTokens_1.kinsideTokens['--gray-80'],
        },
    },
    nextButton: {
        width: 60,
        height: 60,
        borderRadius: 30,
        position: 'absolute',
        right: -30,
        top: 'calc((100vh - 4rem - 60px) / 2)',
        fontSize: 30,
    },
    prevButton: {
        width: 60,
        height: 60,
        borderRadius: 30,
        position: 'absolute',
        left: -30,
        top: 'calc((100vh - 4rem - 60px) / 2)',
        fontSize: 30,
    },
    dialogTitle: {
        fontWeight: 700,
        fontSize: 28,
    },
    divider: {
        height: 4,
    },
    navigation: {
        marginTop: theme.spacing(2),
    },
    progress: {
        width: '100%',
    },
    paper: {
        height: 900,
        overflowY: 'visible',
    },
    hidden: {
        display: 'none',
    },
}); });
var Wizard = function (props) {
    var _a, _b, _c, _d;
    var classes = useStyles(props);
    var _e = react_1.default.useState(props.initialPage || 0), step = _e[0], setStep = _e[1];
    var _f = react_1.default.useState(0), progress = _f[0], setProgress = _f[1];
    var activePages = function () {
        return props.menuData
            .map(function (i, idx) { return (i.made === false ? idx : -1); })
            .filter(function (i) { return i > -1; });
    };
    react_1.default.useEffect(function () {
        setStep(props.initialPage || 0);
    }, [props.initialPage]);
    react_1.default.useEffect(function () {
        if (props.menuData) {
            var totalCheckboxes = props.menuData.filter(function (t) { return t.checkbox === true; }).length;
            var markedCheckboxes = props.menuData.filter(function (t) { return t.made === true; }).length;
            setProgress(Math.floor((markedCheckboxes * 100) / totalCheckboxes));
        }
    }, [props.menuData]);
    var handleBack = function () {
        var pagesToMove = 0;
        if (props.handleBack) {
            pagesToMove = props.handleBack(step) ? 1 : 0;
        }
        else if (props.handleBackWithSkip) {
            pagesToMove = props.handleBackWithSkip(step);
        }
        else if (props.handleBackDirect) {
            setStep(props.handleBackDirect(step));
        }
        if (pagesToMove) {
            if (!props.menuData) {
                setStep(step - pagesToMove);
            }
            else {
                var backActivePage_1 = step;
                var j = void 0;
                for (j = 0; j < pagesToMove; j++) {
                    backActivePage_1 = activePages().find(function (i) { return i < backActivePage_1; }) || 0;
                }
                setStep(backActivePage_1);
            }
        }
    };
    var handleNext = function () {
        var pagesToMove = 0;
        if (props.handleNext) {
            pagesToMove = props.handleNext(step) ? 1 : 0;
        }
        else if (props.handleNextWithSkip) {
            pagesToMove = props.handleNextWithSkip(step);
        }
        else if (props.handleNextDirect) {
            setStep(props.handleNextDirect(step));
        }
        if (pagesToMove) {
            if (step >= props.pageCount - pagesToMove) {
                props.onComplete();
            }
            else if (!props.menuData) {
                setStep(step + pagesToMove);
            }
            else if (!props.proceed || props.proceed[step]) {
                var nextActivePage_1 = step;
                var j = void 0;
                for (j = 0; j < pagesToMove; j++) {
                    nextActivePage_1 = activePages().find(function (i) { return i > nextActivePage_1; });
                }
                setStep(nextActivePage_1);
            }
        }
    };
    var handleClose = function () {
        if (step === props.pageCount - 1 && props.finalPageConfirm) {
            props.onComplete();
        }
        else {
            props.onClose();
        }
    };
    var renderMenu = function () {
        return (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 5, md: 4, lg: 3 },
            react_1.default.createElement(List_1.default, null, props.menuData.map(function (i, idx) {
                return (react_1.default.createElement(ListItem_1.default, { onClick: props.clickableMenu ? function () { return setStep(idx); } : undefined, key: idx, selected: idx === step ? true : false, style: props.clickableMenu ? { cursor: 'pointer' } : undefined },
                    react_1.default.createElement(ListItemIcon_1.default, null, i.checkbox ? (react_1.default.createElement(Checkbox_1.default, { checked: i.made })) : (react_1.default.createElement("div", { style: { width: 42 } }))),
                    react_1.default.createElement(ListItemText_1.default, null, i.title)));
            })),
            react_1.default.createElement(Grid_1.default, { container: true, spacing: 1 },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 10, style: { paddingTop: 10 } },
                    react_1.default.createElement(LinearProgress_1.default, { variant: "determinate", color: "secondary", value: progress })),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 2, style: { paddingTop: 0 } },
                    react_1.default.createElement(Typography_1.default, null, progress + "%")))));
    };
    var renderContent = function () {
        return (react_1.default.createElement(Grid_1.default, { container: true, style: { display: 'flex' } },
            props.menuData ? renderMenu() : null,
            react_1.default.createElement(Grid_1.default, { item: true, xs: props.menuData ? 7 : 12, md: props.menuData ? 8 : 12, lg: props.menuData ? 9 : 12 }, props.renderPage(step))));
    };
    var renderFloatingButtons = function () {
        var hidden = props.hideNavigation && props.hideNavigation[step];
        return (react_1.default.createElement(Grid_1.default, { container: true, className: classes.navigation },
            react_1.default.createElement("div", null, step === 0 ||
                (props.finalPageConfirm && step === props.pageCount - 1) ? null : (react_1.default.createElement(Button_1.default, { variant: "contained", size: "small", color: "primary", ref: props.backButtonRef, onClick: handleBack, className: hidden ? classes.hidden : classes.prevButton }, "<"))),
            react_1.default.createElement(Grid_1.default, { container: true, item: true, xs: 8, justify: "flex-end" },
                react_1.default.createElement(Button_1.default, { variant: "contained", size: "small", color: "primary", ref: props.nextButtonRef, onClick: handleNext, className: hidden ? classes.hidden : classes.nextButton }, ">"))));
    };
    var renderNavigation = function () {
        var hidden = props.hideNavigation && props.hideNavigation[step];
        return (react_1.default.createElement(Grid_1.default, { container: true, className: classes.navigation },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 4 }, step === 0 ||
                (props.finalPageConfirm && step === props.pageCount) ? null : (react_1.default.createElement(Button_1.default, { onClick: handleBack, className: hidden ? classes.hidden : classes.button, ref: props.backButtonRef }, props.backButtonText ? props.backButtonText[step] : strings_1.default.back))),
            react_1.default.createElement(Grid_1.default, { container: true, item: true, xs: 8, justify: "flex-end" },
                react_1.default.createElement(Button_1.default, { variant: "contained", size: "small", color: "secondary", ref: props.nextButtonRef, onClick: handleNext, className: hidden ? classes.hidden : classes.button }, props.nextButtonText ? props.nextButtonText[step] : strings_1.default.next))));
    };
    var renderProgressBar = function () {
        var steps = [];
        for (var i = 0; i < props.pageCount; i++) {
            steps.push(i);
        }
        return (react_1.default.createElement(react_1.default.Fragment, null, steps.map(function (s) {
            return step === s ? (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleDot })) : (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircle }));
        })));
    };
    if (!props.open && !props.fullScreen) {
        return null;
    }
    if (props.fullScreen) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Grid_1.default, { container: true },
                !!props.title && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 8, md: 9 },
                    react_1.default.createElement("div", { className: classes.dialogTitle }, props.title))),
                props.progressBar ? (react_1.default.createElement(Grid_1.default, { container: true, alignContent: "center", xs: 12, sm: 4, md: 3 }, renderProgressBar())) : null),
            !!props.floatingButtons && renderFloatingButtons(),
            !!props.title && (react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.divider })),
            renderContent(),
            !props.floatingButtons && renderNavigation()));
    }
    var contentStyle = {};
    if (((_a = props.wizardSize) === null || _a === void 0 ? void 0 : _a.reducePadding) === 'both' ||
        ((_b = props.wizardSize) === null || _b === void 0 ? void 0 : _b.reducePadding) === 'horizontal') {
        contentStyle.paddingLeft = '4px';
        contentStyle.paddingRight = '4px';
    }
    if (((_c = props.wizardSize) === null || _c === void 0 ? void 0 : _c.reducePadding) === 'both' ||
        ((_d = props.wizardSize) === null || _d === void 0 ? void 0 : _d.reducePadding) === 'vertical') {
        contentStyle.paddingTop = '0px';
        contentStyle.paddingBottom = '0px';
    }
    return (react_1.default.createElement(Dialog_1.default, { PaperProps: props.paperProps, style: { color: 'blue' }, fullScreen: props.wizardSize.fullScreen, fullWidth: props.wizardSize.fullWidth, maxWidth: props.wizardSize.maxWidth, classes: props.wizardSize.customHeight ? { paper: classes.paper } : null, "aria-labelledby": "simple-dialog-title", open: props.open },
        react_1.default.createElement(DialogTitle_1.default, { className: classes.root, id: "simple-dialog-title" },
            react_1.default.createElement(Grid_1.default, { container: true },
                !!props.title && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 8, md: 9 },
                    react_1.default.createElement("div", { className: classes.dialogTitle }, props.title))),
                props.progressBar ? (react_1.default.createElement(Grid_1.default, { container: true, alignContent: "center", xs: 12, sm: 4, md: 3 }, renderProgressBar())) : null)),
        !props.hideClose || !props.hideClose[step] ? (react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: classes.closeButton, onClick: handleClose, color: "primary" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faXmark }))) : null,
        !!props.floatingButtons && renderFloatingButtons(),
        react_1.default.createElement(DialogContent_1.default, { style: Object.keys(contentStyle).length ? contentStyle : undefined },
            !!props.title && (react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.divider })),
            renderContent(),
            !props.floatingButtons && renderNavigation())));
};
exports.Wizard = Wizard;
